import reducerRegistry from 'reduxUtils/reducerRegistry';
import makeRequest from 'utils/makeRequest';
import { getJarvisFeedURL } from '../../utils/common';

const reducerName = 'revenue';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const UPDATE_AD_DATA = createActionName('UPDATE_AD_DATA');

const removeSplchFromStr = str => {
  try {
    if (typeof str === 'string') {
      return str.replace(/[^a-zA-Z0-9\-\/]/g, '').toLowerCase();
    }
    return str;
  } catch (e) {
    return str;
  }
};

function fetchJarvisAdsData(templateConfig = {}) {
  // SubSCN
  /* eslint-disable camelcase */
  const {
    Tmpl_SCN,
    SCN,
    Channel,
    platform,
    SubSCN,
    LastSubSCN,
    LastSubSCN_Child_1,
    specialId,
    contentType,
    Hyp1,
  } = templateConfig;
  let path = Tmpl_SCN ? `&pagename=${Tmpl_SCN}` : '';
  path += platform ? `&platform=${platform}` : '';
  path += SCN ? `&sectionl1=${removeSplchFromStr(SCN)}` : '';
  path += SubSCN ? `&sectionl2=${removeSplchFromStr(SubSCN)}` : '';
  path += LastSubSCN ? `&sectionl3=${removeSplchFromStr(LastSubSCN)}` : '';
  path += LastSubSCN_Child_1
    ? `&sectionl4=${removeSplchFromStr(LastSubSCN_Child_1)}`
    : '';
  path += Channel ? `&business=${Channel}` : '';
  const splid = specialId || contentType || Hyp1;
  path += splid ? `&keywords=${removeSplchFromStr(splid)}` : '';

  const url = `${getJarvisFeedURL('/revenue/toi_ssr_config', path)}`;
  return { api: makeRequest.get(url), path };
}

export function receiveAdsData(data) {
  return {
    type: RECEIVE_DATA,
    payload: {
      data,
    },
  };
}
function handleAdsDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    payload: {
      error,
    },
  };
}
export function updatelayoutAdsData(payload) {
  return {
    type: UPDATE_AD_DATA,
    payload,
  };
}
//exposed functions
export function loadPageAdCode(templateConfig, platform) {
  templateConfig.platform = templateConfig.platform || platform;
  return dispatch => {
    const { api, path } = fetchJarvisAdsData(templateConfig);
    return api
      .then(data => {
        const payload = {
          ...data.data,
          path,
        };
        dispatch(receiveAdsData(payload));
      })
      .catch(error => {
        dispatch(handleAdsDataError(error));
      });
  };
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA: {
      return {
        ...state,
        data: action.payload.data,
      };
    }
    case UPDATE_AD_DATA: {
      if (!state?.data?.ads) {
        return {
          data: {
            ads: action.payload,
          },
        };
      }
      return state;
    }
    case HANDLE_DATA_ERROR: {
      return {
        ...state,
        error: action.payload.error,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
